import { PauseCircleOutlined } from '@ant-design/icons'
import { Flex, Tag } from 'antd'
import { FC } from 'react'
import PrintQueueEntry from '../../../../../types/api/print-queue-entry'
import { isPrintJobPaused } from '../helpers/print-job-helpers'
import CancelPrint from './cancel-print'
import FinishPrint from './finish-print'
import StartPrint from './start-print'

interface ActionsCellProps {
    printQueueEntry: PrintQueueEntry
}

const ActionsCell: FC<ActionsCellProps> = ({ printQueueEntry }) => {
    const isPaused = isPrintJobPaused(printQueueEntry.print_job)

    return (
        <Flex gap={8} align="center" wrap="wrap">
            {isPaused && (
                <Tag icon={<PauseCircleOutlined />} color="warning" style={{ margin: 0 }}>
                    Пауза
                </Tag>
            )}
            <StartPrint printQueueEntry={printQueueEntry} />
            <FinishPrint printQueueEntry={printQueueEntry} />
            <CancelPrint printQueueEntry={printQueueEntry} />
        </Flex>
    )
}

export default ActionsCell
